import React, { useState, useEffect } from 'react';
import './Gallery.css';
import GalleryModal from './GalleryModal';
import { useLanguage } from '../context/LanguageContext';

// Import gallery images and videos
import imageGal1 from './images/image-gal1.jpeg';
import imageGal2 from './images/image-gal2.jpeg';
import imageGal3 from './images/image-gal3.jpeg';
import imageGal4 from './images/image-gal4.jpeg';
import imageGal5 from './images/image-gal5.jpeg';
import video1 from './videos/video1.mp4';
import video2 from './videos/video2.mp4';
import video3 from './videos/video3.mp4';

const Gallery = () => {
  const { t } = useLanguage();
  const [modalOpen, setModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  // Use the new gallery images and videos
  const galleryImages = [
    imageGal1,
    imageGal2,
    imageGal3,
    imageGal4,
    imageGal5,
    video1,
    video2,
    video3
  ];
  
  // Helper function to check if item is a video
  const isVideo = (src) => {
    return src && (src.endsWith('.mp4') || src.endsWith('.webm') || src.endsWith('.ogg'));
  };
  
  // Helper function to detect mobile devices
  const isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) 
      || window.innerWidth <= 768;
  };
  
  // Helper function to get CSS classes for gallery items
  const getItemClasses = (index) => {
    switch(index) {
      case 0: return 'wide';
      case 1: return 'tall'; 
      case 4: return 'wide tall';
      default: return '';
    }
  };
  
  // Add URLs for each gallery item
  const galleryImageUrls = [
    'https://example.com/tattoo-design-1',
    'https://example.com/tattoo-design-2',
    'https://example.com/tattoo-design-3',
    'https://example.com/tattoo-design-4',
    'https://example.com/tattoo-design-5',
    'https://example.com/tattoo-video-1',
    'https://example.com/tattoo-video-2',
    'https://example.com/tattoo-video-3'
  ];
  
  // Add Instagram URLs for each gallery item
  const instagramUrls = [
    'https://www.instagram.com/kellink_tattoo/profilecard/?igsh=MThoeTcxZzdldGV4cA%3D%3D',  
    'https://www.instagram.com/kellink_tattoo/profilecard/?igsh=MThoeTcxZzdldGV4cA%3D%3D',
    'https://www.instagram.com/kellink_tattoo/profilecard/?igsh=MThoeTcxZzdldGV4cA%3D%3D',
    'https://www.instagram.com/kellink_tattoo/profilecard/?igsh=MThoeTcxZzdldGV4cA%3D%3D',
    'https://www.instagram.com/kellink_tattoo/profilecard/?igsh=MThoeTcxZzdldGV4cA%3D%3D',
    'https://www.instagram.com/kellink_tattoo/profilecard/?igsh=MThoeTcxZzdldGV4cA%3D%3D',
    'https://www.instagram.com/kellink_tattoo/profilecard/?igsh=MThoeTcxZzdldGV4cA%3D%3D',
    'https://www.instagram.com/kellink_tattoo/profilecard/?igsh=MThoeTcxZzdldGV4cA%3D%3D'
  ];
  
  // Add Facebook URLs for each gallery item
  const facebookUrls = [
    'https://www.facebook.com/conlitchenko.gabriel?mibextid=wwXIfr&rdid=1mKh9PqMCPjaOBq3&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1DYWFGYEgg%2F%3Fmibextid%3DwwXIfr#',    
    'https://www.facebook.com/conlitchenko.gabriel?mibextid=wwXIfr&rdid=1mKh9PqMCPjaOBq3&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1DYWFGYEgg%2F%3Fmibextid%3DwwXIfr#',
    'https://www.facebook.com/conlitchenko.gabriel?mibextid=wwXIfr&rdid=1mKh9PqMCPjaOBq3&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1DYWFGYEgg%2F%3Fmibextid%3DwwXIfr#',
    'https://www.facebook.com/conlitchenko.gabriel?mibextid=wwXIfr&rdid=1mKh9PqMCPjaOBq3&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1DYWFGYEgg%2F%3Fmibextid%3DwwXIfr#',
    'https://www.facebook.com/conlitchenko.gabriel?mibextid=wwXIfr&rdid=1mKh9PqMCPjaOBq3&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1DYWFGYEgg%2F%3Fmibextid%3DwwXIfr#',
    'https://www.facebook.com/conlitchenko.gabriel?mibextid=wwXIfr&rdid=1mKh9PqMCPjaOBq3&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1DYWFGYEgg%2F%3Fmibextid%3DwwXIfr#',
    'https://www.facebook.com/conlitchenko.gabriel?mibextid=wwXIfr&rdid=1mKh9PqMCPjaOBq3&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1DYWFGYEgg%2F%3Fmibextid%3DwwXIfr#',
    'https://www.facebook.com/conlitchenko.gabriel?mibextid=wwXIfr&rdid=1mKh9PqMCPjaOBq3&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1DYWFGYEgg%2F%3Fmibextid%3DwwXIfr#'
  ];

  // Function to open the modal with a specific image
  const openModal = (index) => {
    setCurrentImageIndex(index);
    setModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setModalOpen(false);
  };

  // Function to navigate to previous image
  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? galleryImages.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to next image
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === galleryImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Handle ResizeObserver errors (common on mobile with videos)
  useEffect(() => {
    const handleResizeObserverError = (e) => {
      if (e.message && e.message.includes('ResizeObserver loop completed with undelivered notifications')) {
        e.preventDefault();
        e.stopPropagation();
        // Silently suppress this common mobile video error
        return false;
      }
    };
    
    window.addEventListener('error', handleResizeObserverError);
    return () => window.removeEventListener('error', handleResizeObserverError);
  }, []);

  return (
    <div className="gallery-section" id="gallery">
      <div className="gallery-container">
        <div className="gallery-header">
          <h2 className="gallery-title">{t('gallery.title')}</h2>
          <p className="gallery-subtitle">{t('gallery.subtitle')}</p>
        </div>

        <div className="gallery-grid">
          {galleryImages.map((item, index) => (
            <div 
              key={index} 
              className={`gallery-item ${getItemClasses(index)}`} 
              onClick={() => openModal(index)}
            >
              {isVideo(item) ? (
                <video 
                  src={item} 
                  className="gallery-image" 
                  muted 
                  loop 
                  preload="metadata"
                  playsInline
                  {...(!isMobile() && {
                    onMouseEnter: (e) => {
                      try {
                        e.target.play();
                      } catch (error) {
                        // Silently handle play errors
                      }
                    },
                    onMouseLeave: (e) => {
                      try {
                        e.target.pause();
                      } catch (error) {
                        // Silently handle pause errors
                      }
                    }
                  })}
                />
              ) : (
                <img src={item} alt={`Gallery item ${index + 1}`} className="gallery-image" />
              )}
              
              {!isVideo(item) && (
                <div className="gallery-social-overlay">
                  <div className="social-icons-container">
                    <a 
                      href={instagramUrls[index]} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="social-icon" 
                      title={t('gallery.instagram')}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                    <span className="social-divider"></span>
                    <a 
                      href={facebookUrls[index]} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="social-icon" 
                      title={t('gallery.facebook')}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Modal component for fullscreen view */}
        <GalleryModal
          isOpen={modalOpen}
          currentImageIndex={currentImageIndex}
          images={galleryImages}
          imageUrls={galleryImageUrls}
          onClose={closeModal}
          onPrevious={prevImage}
          onNext={nextImage}
        />
      </div>
    </div>
  );
};

export default Gallery; 